import { MEETING_BUTTON_HELPER_MSGS } from "../../../../utility/constants";
import { useVideoMeetingEvents } from "./VideoMeetingEventProvider";

/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
export const MeetingButton = (props) => {
	const { handleInitMeeting, classes, isCustomerMediaSupported } = props;
	const { activeContactId, inMeetingContactId, isMeetingRequested } = useVideoMeetingEvents();

	let errorMessage = "";
	if (!isCustomerMediaSupported) {
		errorMessage = MEETING_BUTTON_HELPER_MSGS.CUST_MEDIA_NOT_SUPPORTED;
	} else if (!activeContactId) {
		errorMessage = MEETING_BUTTON_HELPER_MSGS.NO_ACTIVE_CONTACTS;
	} else if (!inMeetingContactId && isMeetingRequested) {
		errorMessage = MEETING_BUTTON_HELPER_MSGS.ACCEPT_MEETING;
	} else if (inMeetingContactId && inMeetingContactId !== activeContactId) {
		errorMessage = MEETING_BUTTON_HELPER_MSGS.OTHER_MEETING_INPROGRESS;
	}

	return (
		<main className={classes.paceJoinMeetingPage}>
			<div className="text-secondary" style={{ opacity: 0.5, padding: "40px 0" }}>
				<h4>Video/Screen Sharing</h4>
				<span>Initiate a meeting to enable video and screen sharing.</span>
			</div>
			<div className="m-auto d-flex flex-column align-items-center" style={{ padding: "40px 0", gap: 10 }}>
				<button
					type="button"
					className="btn btn-outline-secondary"
					style={{ maxWidth: 250 }}
					disabled={!!inMeetingContactId || !activeContactId || !isCustomerMediaSupported}
					onClick={handleInitMeeting}
				>
					{isMeetingRequested ? `Accept Meeting` : `Initiate Meeting`}
				</button>
				{errorMessage && (
					<div className="d-inline text-sm" style={{ opacity: 0.5 }}>
						<p>
							<small>
								<i className="fas fa-exclamation-circle"></i> {errorMessage}
							</small>
						</p>
					</div>
				)}
			</div>
		</main>
	);
};
